// extracted by mini-css-extract-plugin
export default {"offlineBanner":"Style_offlineBanner__R6gCr"};